import { createContext, useContext, useState } from "react";
import { fetchData } from "../../../lib/dashboard/data";
import useSWR, { mutate } from "swr";
import { deleteData } from "../../../lib/dashboard/actions";

const DomesticMarketProductPriceChartContext = createContext();

const DomesticMarketProductPriceChartProvider = ({ children }) => {
  const [isFavoritesModal, setIsFavoritesModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState("producer");

  const { data: favorites } = useSWR(
    selectedTab === "producer"
      ? "/favorite/domestic-price/producer"
      : "/favorite/domestic-price/category",
    fetchData,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const handleDeleteFavorite = async (id, e) => {
    e.stopPropagation();
    const { status } = await deleteData(
      selectedTab === "producer"
        ? `/favorite/domestic-price/producer/${id}`
        : `/favorite/domestic-price/category/${id}`
    );
    if (status === 200)
      await mutate(
        selectedTab === "producer"
          ? "/favorite/domestic-price/producer"
          : "/favorite/domestic-price/category"
      );
  };

  return (
    <DomesticMarketProductPriceChartContext.Provider
      value={{
        isFavoritesModal,
        setIsFavoritesModal,
        favorites,
        selectedTab,
        setSelectedTab,
        handleDeleteFavorite,
      }}
    >
      {children}
    </DomesticMarketProductPriceChartContext.Provider>
  );
};

export default DomesticMarketProductPriceChartProvider;

export const useDomesticMarketProductPriceChart = () => {
  return useContext(DomesticMarketProductPriceChartContext);
};
